export default __webpack_public_path__ + "static/media/GHSI Performance Assessment of Management Team Policy.4e8c1a95.pdf";